import { Record } from 'immutable';
import { AgGridState } from '@/domain/agGrid/types';

const defaultState: AgGridState = {
  refreshServerSide: null,
  refreshColumnDefs: null,
};

export const AGGridStateFactory = Record<AgGridState>(defaultState);
